const firebaseConfig = {
  apiKey: 'AIzaSyDCKibznJSv0-KZwX2iNKl_Xm2ZAMnuNLY',
  authDomain: 'capstone-project-sib3.firebaseapp.com',
  databaseURL: 'https://capstone-project-sib3-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'capstone-project-sib3',
  storageBucket: 'capstone-project-sib3.appspot.com',
  messagingSenderId: '1034803075706',
  appId: '1:1034803075706:web:692fce32acc7a94ee2f9c3',
  measurementId: 'G-KTWTXBRJ6N',
};

export default firebaseConfig;
